module.exports = __webpack_public_path__ + "static/media/background.08376346.png";